module.exports = __webpack_public_path__ + "img/bg_main_r_1.b0fd272f.png";